import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'

import { useStores } from '@trivie/core'
import { color } from '@trivie/ui-web/theme'
import { SubscriptionCard } from '@trivie/ui-mobile'

export interface SubscriptionsTabProps {
  searchTerm?: string
}

const formatDate = (dateString: string) => {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export const SubscriptionsTab = observer((props: SubscriptionsTabProps) => {
  const { subscriptionStore } = useStores()
  const { sortedUserSubscriptions } = subscriptionStore
  const { searchTerm } = props

  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 })

  const history = useHistory()

  function useWindowSize() {
    useEffect(() => {
      function handleResize() {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        })
      }
      window.addEventListener('resize', handleResize)
      handleResize()
      return () => window.removeEventListener('resize', handleResize)
    }, [])
    return windowSize
  }

  useWindowSize()
  function responsiveGrid() {
    if (windowSize.width < 1024) {
      return THINGRID
    } else if (windowSize.width < 1440) {
      return NORMALGRID
    } else {
      return WIDEGRID
    }
  }

  const filteredData = sortedUserSubscriptions
    .slice()
    .filter(
      (item) =>
        !searchTerm || item.title.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()),
    )

  return (
    <div style={CONTENT}>
      <div style={responsiveGrid()}>
        {filteredData.map((item, index) => {
          const statusLabel = `Active · Exp ${formatDate(item.expiration_date!)}`
          const expiredLabel = `Expired on ${formatDate(item.expiration_date!)}`

          return (
            <SubscriptionCard
              key={`subscription-${item.id}`}
              title={item.title}
              accentColor={item.color}
              description={item.description}
              statusLabel={statusLabel}
              expiredLabel={expiredLabel}
              expired={item.isExpired}
              expirationDate={item.expiration_date ?? undefined}
              onPress={() =>
                history.push(`/library/subscription/?subscription_id=${item.purchase_id}`)
              }
            />
          )
        })}
      </div>
    </div>
  )
})

/**
 * Styling
 */
const CONTENT: React.CSSProperties = {
  backgroundColor: color.white,
  height: '100%',
}
const WIDEGRID: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: '1fr',
  gridGap: 20,
  paddingTop: 0,
  paddingBottom: 20,
}
const NORMALGRID: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: '1fr',
  gridGap: 20,
  paddingTop: 0,
  paddingBottom: 20,
}
const THINGRID: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: '1fr',
  gridGap: 20,
  paddingTop: 0,
  paddingBottom: 20,
}
